import React, { useState } from 'react';
import styles from "assets/scss/task_management.module.css";
import { useBaseModal } from 'services';
import UpdateTask from './UpdateTask';
import ReAssignTask from '../Employee/ReAssignTask';
import { getOverdueTime, getTextColor } from "services/util";
import { Trans } from 'react-i18next';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

function TaskCard({ task, onDelete, handleCheckboxChange, onUpdate, t, buckets, availableEmployees, onReassign, fetchLabels, groups, userPermission, activeTab }) {
    const [, toggle, MainModal] = useBaseModal();
    const [, toggleReassign, ReassignModal] = useBaseModal();
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    
    const handleDelete = () => {
        onDelete();
    };

    const labelOptions = fetchLabels?.map(label => ({
        value: label?.id,
        label: label?.label_name,
        color_code: label?.color_code,
    }));

    const defaultOptions = task?.task_label?.map(id => {
        const label = labelOptions?.find(label => label?.value === id);
        return { value: id, label: label?.label, color_code: label?.color_code || '', textColor: getTextColor(label?.color_code || '') };
    });

    const handleDeleteBucketTaskClick = (e) => {
        e.stopPropagation();
        setShowModal(true);
        setShowDeleteButton(false);
    };

    const handleConfirmDelete = () => {
        handleDelete();
        setShowModal(false);
    };

    const handleCancelDelete = () => {
        setShowModal(false);
    };

    const handleUpdate = (e) => {
        if (!showDeleteButton) {
            e.stopPropagation();
            toggle();
        }
    };

    const handleReassignClick = (e) => {
        e.stopPropagation();
        toggleReassign();
    };

    const handleReassign = async (selectedEmployees, reason) => {
        await onReassign(task.id, selectedEmployees, reason);
        toggleReassign();
    };

    const handleRadioClick = (e) => {
        e.stopPropagation();
    };

    const handleAssignButtonClick = (e) => {
        e.stopPropagation();
        setShowDropdown(!showDropdown);
    };

    const overdueTime = getOverdueTime(task?.end_date);
    const dueClass = task?.end_date ? (new Date(task?.end_date) < new Date() ? styles.duePassed : styles.dueUpcoming) : styles.noDueDate;

    return (
        <div className={styles.card} onClick={handleUpdate}>
        <div className="d-flex flex-row p-1 rounded">
            <div className="d-flex flex-wrap">
                {defaultOptions?.map((i) => (
                    <span 
                        key={i.value} 
                        style={{
                            borderRadius: '10%', 
                            backgroundColor: i.color_code || '',
                            marginRight: "3px",
                            color: i.textColor || '',
                        }} 
                        className='p-1 mt-1'>
                        {i.label}
                    </span>
                ))}
            </div>
            <div className='ml-auto'>
                <Button color='danger' className='p-1' onClick={handleDeleteBucketTaskClick} ><i className='fa fa-trash'/></Button>
            </div>
        </div>
            <div className={styles.content}>
                <div className={styles.radioTitle}>
                    <input
                        type="checkbox"
                        name="taskCheckbox"
                        onChange={(e) => handleCheckboxChange(task, e)}
                        checked={task?.progress === "Completed"}
                        onClick={handleRadioClick}
                    />
                    <span 
                    className={`p-1 ${task?.progress === "Completed" ? styles.inputField + ' ' + styles.textDecorationLineThrough : ''}`}
                    >
                        {task?.bucket_task_name || ""}
                    </span>
                </div>
            </div>
            <div className={styles.line}></div>
            <div className="d-flex justify-content-between align-items-center">
                <div className={`styles.dueDate px-1 py-1`}>
                    <button className={dueClass}>
                        {task?.end_date ? new Date(task?.end_date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }) : "Due"}
                    </button>
                    {overdueTime && (
                        <span className={`${dueClass} mx-1`} style={{paddingTop: "2px", paddingBottom: "3px"}}>{overdueTime}</span>
                    )}
                </div>
                <div className='float-right'>
                    {task?.employee?.length > 0 && (
                        <Button size='sm' color="primary" className='p-1' onClick={handleAssignButtonClick}><i className='fa fa-user p-1'/></Button>
                    )}
                    {userPermission ? (
                            <Button size='sm' color="primary" onClick={handleReassignClick}><Trans>Re Assign</Trans></Button>
                    ) :
                     (
                        task?.allow_update && (
                            <Button size='sm' color="primary" onClick={handleReassignClick}><Trans>Re Assign</Trans></Button>
                        )
                     )}
                </div>
            </div>
            <MainModal title={t("Update Task")} action="Update">
                <UpdateTask
                    task={task}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                    onClose={toggle}
                    availableEmployees={availableEmployees}
                    fetchLabels={fetchLabels}
                    groups={groups}
                    buckets={buckets}
                    userPermission={userPermission}
                    activeTab={activeTab}
                    t={t}
                />
            </MainModal>
            <ReassignModal title={t("Reassign Task")}>
                <ReAssignTask
                    task={task}
                    onClose={toggleReassign}
                    availableEmployees={availableEmployees}
                    onReassign={handleReassign}
                    t={t}
                    userPermission={userPermission}
                />
            </ReassignModal>
            <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
                <ModalHeader toggle={() => setShowModal(false)}><Trans>Confirm Delete</Trans></ModalHeader>
                <ModalBody>
                    <Trans>Are you sure you want to delete </Trans> <strong>{task?.bucket_task_name}</strong>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleConfirmDelete}>
                        <Trans>Delete</Trans>
                    </Button>{' '}
                    <Button color="secondary" onClick={handleCancelDelete}>
                        <Trans>Cancel</Trans>
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal size='md' isOpen={showDropdown} toggle={() => setShowDropdown(false)}>
                <ModalHeader toggle={() => setShowDropdown(false)}> <Trans>Assigned Employees</Trans></ModalHeader>
                <ModalBody>
                {showDropdown && (
                            <div className={styles.dropdownContent}>
                                {task?.employee?.length > 0 && (
                                    <>
                                        {task?.employee?.map(employeeId => (
                                            <button key={employeeId} className={styles.assignedEmployee}>
                                                {availableEmployees.find(employee => employee.id === employeeId)?.full_name} 
                                                {/* <FaTimes onClick={() => handleRemoveEmployee(employeeId)} /> */}
                                            </button>
                                        ))}
                                    </>
                                )}
                            </div>
                        )}
                </ModalBody>
            </Modal>
        </div>
    );
}

export default TaskCard;